export default __webpack_public_path__ + "a5e448ac34d882ee7cff79e904ab787a.png";